// Get the parent container of the buttons
const tabGroup = document.querySelector('#gallery_tab .tab-group');
// Add click event listener to the container
tabGroup.addEventListener('click', function(event) {
  // Check if the clicked element is a button
  if (event.target.tagName.toLowerCase() === 'button') {
    // Remove 'active' class from all buttons
    const buttons = tabGroup.querySelectorAll('button');
    buttons.forEach(button => button.classList.remove('active'));
    
    // Add 'active' class to the clicked button
    event.target.classList.add('active');
  }
});

document.querySelector("#gallery_tab .tab-group .tattoos").addEventListener("click", function() {
  document.querySelector("#gallery_tab .gallery-content").classList.remove("active");
  document.querySelector("#gallery_tab #enap-gallery-93198").classList.add("active");
});
document.querySelector("#gallery_tab .tab-group .body-piercing").addEventListener("click", function() {
  document.querySelector("#gallery_tab .gallery-content").classList.remove("active");
  
});
document.querySelector("#gallery_tab .tab-group .permanent-jewelry").addEventListener("click", function() {
  document.querySelector("#gallery_tab .gallery-content").classList.remove("active");
  
});
document.querySelector("#gallery_tab .tab-group .tooth-gems").addEventListener("click", function() {
  document.querySelector("#gallery_tab .gallery-content").classList.remove("active");
  
});